export default __webpack_public_path__ + "static/upipaymentlinksapi-8b12f9590ff0e78ce9af84415f8cb466.webp";